document.addEventListener('DOMContentLoaded' , () =>{
	//main-page	
	if(document.querySelector('.main-page')){
        $('.main-visual').slick({
			lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
			autoplay:true,
			autoplaySpeed:3000,
            speed:1300,
			fade: true,
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$(".main-visual__control .current").html(nextSlide + 1);
		});   
		$(".main-visual__control .total").html($(".main-visual .main-visual__slide").length - 2);

		// 오늘의 건강루틴
		$('.main-user-routine .main-user-routine__slider').slick({
			dots:true,
			arrows:false,
			centerMode:false,
			autoplay:false,
			autoplaySpeed:5000,
			variableWidth: false,
			infinite: false,
			adaptiveHeight: true,
		});

		// 필수영양제
		$('.main-medicine .main-medicine__slider').slick({
			dots:false,
			arrows:false,
			centerMode:true,
			autoplay:true,
			autoplaySpeed:5000,
			variableWidth: true,
			infinite : true
		});
	
		// 섭취스토리
		$('.main-story .main-story__slider').slick({
			dots:false,
			arrows:false,
			centerMode:false,
			autoplay:false,
			autoplaySpeed:5000,
			variableWidth: true,
			infinite : false
		});

		// 정기구독
		$('.main-subscription .main-subscription__slider').slick({
			dots:true,
			arrows:false,
			centerMode:false,
			autoplay:false,
			autoplaySpeed:5000,
			variableWidth: false,
			infinite : true,
		});

		// 배너
		$('.main-cs-banner .main-cs-banner__list').slick({
			lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
            autoplay:true,
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$(".main-cs-banner__control .current").html(nextSlide + 1);
		});

		if($(".main-cs-banner .slick-slide").length <= 1){
			$(".main-cs-banner__control").hide();
		}else{
			$(".main-cs-banner__control .total").html($(".main-cs-banner .slick-slide").length - 2);
		}

		// 나만의 영양제
		const analysisOpen = document.querySelectorAll('.main-analysis__list li');
            
		analysisOpen.forEach((el, index) => {
			el.addEventListener('click', () => {
				// Remove 'on' class from all li elements
				analysisOpen.forEach(index => {
					index.classList.remove('on');
				});
				// Add 'on' class to the clicked li element
				el.classList.add('on');
			});
		});
	}
	
	//intro-slide	
	if(document.querySelector('.intro-slide')){
		const introSlide = $('.intro-slide'),
			  ImagePauses = [2800, 2800, 2800, 5000];

        //첫 slick slide transition 실행
		introSlide.on('init', function(event, slick){
			introSlide.find('.slick-current').removeClass('slick-active').addClass('reset-move');

			setTimeout(function(){
				introSlide.find('.slick-current').removeClass('reset-move').addClass('slick-active');
			}, 1)
		})

        introSlide.slick({
			lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
			autoplay:true,
			autoplaySpeed:ImagePauses[0],
			fade: true,
        }).on('afterChange', function(event, slick, currentSlide, nextSlide){
			// Update autoplay speed according to slide index
			introSlide.slick('slickSetOption', 'autoplaySpeed', ImagePauses[currentSlide], true);
		});   
	}
});
